var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,64) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 320 l0 -240 200 0 200 0 0 240 0 240 -200 0 -200 0 0 -240z m360 0 l0 -200 -160 0 -160 0 0 200 0 200 160 0 160 0 0 -200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 410 l0 -70 120 0 120 0 0 70 0 70 -120 0 -120 0 0 -70z m200 0 l0 -30 -80 0 -80 0 0 30 0 30 80 0 80 0 0 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 260 c0 -19 7 -20 120 -20 113 0 120 1 120 20 0 19 -7 20 -120 20 -113 0 -120 -1 -120 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 180 c0 -19 7 -20 120 -20 113 0 120 1 120 20 0 19 -7 20 -120 20 -113 0 -120 -1 -120 -20z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.12736f6be5898b167b66aa4c3c9f3caa.svg";
export { ForwardRef as ReactComponent };